import React from 'react';
import { Onboarding } from 'pages/onboarding/Onboarding';
import { Route } from 'react-router-dom';
import { KGLOnboardingRoutes } from './routes';
import { Welcome } from './components/Welcome';
import { CheckYourInfo } from './components/CheckYourInfo';

export const EDENOnboarding = () => (
  <Onboarding>
    <Route 
      exact 
      path={KGLOnboardingRoutes.WELCOME} 
      component={Welcome}
    />

    <Route
      exact
      path={KGLOnboardingRoutes.YOUR_INFO}
      component={CheckYourInfo}
    />
  </Onboarding>
);
